import { type Reducer } from "redux"

import { type OneFleetEntregaFormsState, OneFleetEntregaFormsTypes } from "./types"

const INITIAL_STATE: OneFleetEntregaFormsState = {
  data: {},
  PDFPreview: {},
  plateInfo: {}
}

const reducer: Reducer<OneFleetEntregaFormsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case OneFleetEntregaFormsTypes.SET_DATA:
      return { ...state, data: { ...state.data, ...action.payload.data } }

    case OneFleetEntregaFormsTypes.CLEAR_DATA:
      return { ...state, data: { } }

    case OneFleetEntregaFormsTypes.PREVIEW_PDF_REQUEST:
      return { ...state, PDFPreview: { loading: true } }
    case OneFleetEntregaFormsTypes.PREVIEW_PDF_SUCCESS:
      return { ...state, PDFPreview: { pdf: action.payload, loading: false } }
    case OneFleetEntregaFormsTypes.PREVIEW_PDF_FAILURE:
      return { ...state, PDFPreview: { error: true, message: action.payload, loading: false } }
    case OneFleetEntregaFormsTypes.PREVIEW_PDF_CLEAR:
      return { ...state, PDFPreview: { loading: false } }

    case OneFleetEntregaFormsTypes.SEARCH_PLATE_REQUEST:
      return { ...state, plateInfo: { loading: true } }
    case OneFleetEntregaFormsTypes.SEARCH_PLATE_SUCCESS:
      return { ...state, plateInfo: { data: action.payload, loading: false } }
    case OneFleetEntregaFormsTypes.SEARCH_PLATE_FAILURE:
      return { ...state, plateInfo: { error: true, message: action.payload, loading: false } }
    case OneFleetEntregaFormsTypes.SEARCH_PLATE_CLEAR:
      return { ...state, plateInfo: { loading: false } }

    default:
      return state
  }
}

export default reducer
